import { render } from "./ClientHeader.vue?vue&type=template&id=edb17d28"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"

import "./ClientHeader.vue?vue&type=style&index=0&id=edb17d28&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__